export default {
  id: DEMO_CHANNEL_ID,
  title: 'Wix Demo Channel',
};



// WEBPACK FOOTER //
// ./src/shared/constants/demo-channel.js